// 🔧 engagement_event_types.js
// ✅ Purpose: Central registry of all Engagement Intelligence event names
// ✅ Features:
// - Prevents string typos across the application
// - Standardizes Firestore and Google Analytics event names
// - Used by the Engagement Intelligence Engine
// - Designed to expand as new LGV modules integrate

export const ENGAGEMENT_EVENTS = {
  // Passport lifecycle
  PASSPORT_VIEWED: "passport_viewed",
  PASSPORT_STARTED: "passport_started",
  PASSPORT_COMPLETED: "passport_completed",

  // Passport stops
  PASSPORT_STOP_VIEWED: "passport_stop_viewed",
  PASSPORT_STOP_COMPLETED: "passport_stop_completed",

  // Activities
  ACTIVITY_CREATED: "activity_created",
  ACTIVITY_COMPLETED: "activity_completed",

  // Rewards
  POINTS_AWARDED: "points_awarded",
  RAFFLE_ENTRY_AWARDED: "raffle_entry_awarded",

  // QR / Codes
  QR_SCANNED: "qr_scanned",
  PUBLIC_CODE_ENTERED: "public_code_entered",
  BONUS_CODE_ENTERED: "bonus_code_entered",

  // Sponsor
  SPONSOR_VIEWED: "sponsor_viewed",
  SPONSOR_QR_SCANNED: "sponsor_qr_scanned",
  SPONSOR_CTA_CLICKED: "sponsor_cta_clicked",

  // Vendor
  VENDOR_VIEWED: "vendor_viewed",
  VENDOR_QR_SCANNED: "vendor_qr_scanned",
  VENDOR_CTA_CLICKED: "vendor_cta_clicked",

  // LGV
  LGV_CTA_CLICKED: "lgv_cta_clicked",

  ACHIEVEMENTS_VIEWED: "achievements_viewed",

  AUCTION_VIEWED: "auction_viewed",
  AUCTION_BID_PLACED: "auction_bid_placed",
};
